import Footer from "../template/Footer";
import Header from "../template/Header";
import HomeSection from "../template/HomeSection";
// import '../../css/Lesson.module.css'
export default function Lesson() {
    return (
        <>
            <Header />
            <HomeSection breadcrumb={`جلسات دوره`} />
            <div className="container">
                <div className="content">
                    <section className="video-player">
                        <h2>ویدیو درس</h2>
                        <video controls>
                            <source src="path/to/your/video.mp4" type="video/mp4" />
                            مرورگر شما از تگ ویدیو پشتیبانی نمی‌کند.
                        </video>
                    </section>

                    <aside className="lessons-list">
                        <h2>جلسات دوره</h2>
                        <ul>
                            <li><a href="#">جلسه 1: مقدمه‌ای بر هوش مصنوعی</a></li>
                            <li><a href="#">جلسه 2: یادگیری ماشین چیست؟</a></li>
                            <li><a href="#">جلسه 3: شبکه‌های عصبی و یادگیری عمیق</a></li>
                            <li><a href="#">جلسه 4: کاربردهای هوش مصنوعی</a></li>
                        </ul>
                    </aside>
                </div>
            </div>

            <Footer />
        </>
    )
}